import {Selectors} from '../Settings';
import Promotool from "../Components/Promotool";

class PromotoolController {
  constructor() {
    if(document.querySelector(Selectors.PROMOTOOL)) {
      new Promotool(document.querySelector(Selectors.PROMOTOOL));
    }
  }
}

export default PromotoolController;
